import { getClientPortalBase } from "@/lib/clientPortalPaths";
import { Navigate, useParams } from "react-router-dom";

/** Redireciona URLs antigas `/cliente/tickets/new` para a lista (criação é no drawer). */
export default function ClientTicketsNewRedirect() {
  const { tenant } = useParams<{ tenant?: string }>();
  const base = tenant ? `/${encodeURIComponent(tenant)}/cliente/tickets` : getClientPortalBase() + "/tickets";
  return <Navigate to={base} replace />;
}
